export enum DatumsFormatOptions{
    YEAR = 3,
    MONTH_YEAR = 2,
    DAY_MONTH_YEAR = 1,
}

export enum FnType{
    TEXT = 1,
    SELECT = 2,
    DATE = 3,
}

export enum BoxType{
    ALERT = 1,
    CONFIRM_OK_ABBRECHEN = 2,
    CONFIRM_JA_NEIN = 3,
}
